import { PLATFORMS } from '@domain/platform';
import { editUserConfig, getUserConfigData } from '@domain/user-config';
import { createMiddleware } from '@shared/redux';
import { showErrorToast } from '@shared/toasts';
import { GET_CAMPAIGNS_REQUEST_FAILED, GET_CAMPAIGNS_REQUEST_SUCCEEDED, mobeesCampaignSelector } from './campaign-table.state';

export const campaignTableMiddleware = createMiddleware({
    [GET_CAMPAIGNS_REQUEST_SUCCEEDED]: (state) => {
        const campaigns = mobeesCampaignSelector(state);
        const userConfig = getUserConfigData(state);
        const showMobeesOnboardingModal = userConfig
            .PARTNERSHIPS?.ONBOARDING_MODAL?.[PLATFORMS.MOBEES.value] || false;
        const hasCampaigns = campaigns?.length > 0;

        if (hasCampaigns && !showMobeesOnboardingModal) {
            const newUserConfig = {
                configs: {
                    PARTNERSHIPS: {
                        ONBOARDING_MODAL: {
                            ...userConfig?.PARTNERSHIPS?.ONBOARDING_MODAL,
                            [PLATFORMS.MOBEES.value]: hasCampaigns,
                        },
                    },
                },
            };

            return editUserConfig(newUserConfig);
        }

        return [];
    },
    [GET_CAMPAIGNS_REQUEST_FAILED]: () => [
        showErrorToast({
            message: 'There was an error loading your campaigns. Try again in a few minutes.',
        }),
    ],
});
